import { defineStore } from "pinia";
import axios from "axios";
import { useApplicationStore } from "@/state/pinia";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        currentUser: JSON.parse(sessionStorage.getItem('waos_rm.auth.currentUser')),
        username: "",
        password: "",
        authError: null,
        isAuthError: false
    }),
    getters: {
        loggedIn() {
            return !!this.currentUser
        },
        token(){
            return this.currentUser !=null ? this.currentUser.accessToken : ''
        },
        expires(){
            return this.currentUser !=null ? this.currentUser.expires : 0
        },
        token2(){
            return this.currentUser !=null ? this.currentUser.refreshToken : ''
        },
        currentTimeStamp(){
            return Math.round(Date.now() / 1000)
        },
        validToken(){
            return this.expires > this.currentTimeStamp
        }
    },
    actions: {
        setLoginError(error, hasError){
            this.isAuthError = hasError;
            this.authError = error ? error : "";
        },
        setUser(user) {
            this.currentUser = user
            window.sessionStorage.setItem('waos_rm.auth.currentUser', JSON.stringify(user))
        },

        logIn(){
            this.setLoginError(null, false)
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            axios.post(process.env.VUE_APP_URL+'api/auth/login',{username:this.username,password:this.password}).then((response) => {
                this.setLoginError(null, false)
                this.setUser(response.data)
            }).catch(() => {
                this.setLoginError('user.login.error', true)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        },
        async logOut(){
            try {
                await axios.get(process.env.VUE_APP_URL + 'api/auth/logout', {headers: {Authorization: `Bearer ${this.token}`}});
            }finally {
                this.setUser(null);
                window.location.href = "/login"
            }
        },
        async refreshToken() {
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            return await new Promise((resolve, reject) => {
                if (this.validToken === false) {
                    axios.post(process.env.VUE_APP_URL + 'api/auth/refresh', {refreshToken: this.token2}).then((response) => {
                        this.setUser(response.data)
                        resolve(true)
                    }).catch(() => {
                        this.setLoginError('user.login.error', true)
                        reject(null);
                    }).finally(() => {
                        appStore.setLoading(false)
                    })
                }
                resolve(true)
            })

        },
    },
})
